<div class="form-modal modal-theme">
  <h1 mat-dialog-title>{{model.Name}}</h1>
  <div mat-dialog-content>
    <div class="form-horizontal modal-dialog-custom">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <div class="col-sm-12">
              <div class="row no-margin-top">
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="{{'INTERNALID'|translate}}" [(ngModel)]="model.InternalID"
                      [disabled]="true">
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="{{'TAXNUMBER'|translate}}" [(ngModel)]="model.TaxNumber"
                      [disabled]="true">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <input type="text" matInput placeholder="{{'NAME'|translate}}" [(ngModel)]="model.Name"
                  [disabled]="true">
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-8">
              <mat-form-field class="full-width">
                <input type="text" matInput placeholder="{{'GLNCODE'|translate}}" [(ngModel)]="model.GLNCode"
                  [disabled]="true">
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <input type="text" matInput placeholder="{{'ADDRESS'|translate}}" [(ngModel)]="model.Street"
                  [disabled]="true">
              </mat-form-field>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-12">
              <div class="row no-margin-top">
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="{{'POSTAL_CODE'|translate}}" [(ngModel)]="model.PostalCode"
                      [disabled]="true">
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="{{'CITY'|translate}}" [(ngModel)]="model.City"
                      [disabled]="true">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-12">
              <div class="row no-margin-top">
                <div class="col-sm-6" *ngIf="showCounty">
                  <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="{{'COUNTY'|translate}}" [(ngModel)]="model.Municipality"
                      [disabled]="true">
                  </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="full-width">
                    <input type="text" matInput placeholder="{{'COUNTRY'|translate}}" [(ngModel)]="companyCountry"
                      [disabled]="true">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="col-sm-6">
              <mat-form-field class="full-width">
                <input type="text" matInput placeholder="{{'CAPITAL'|translate}}" [(ngModel)]="model.CapitalStock"
                  [disabled]="true" class="text-right">
                <span matSuffix>&nbsp;{{currency}}</span>
              </mat-form-field>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>